<template>
    <div :key="key" class="checkbox-custom">
        <el-checkbox 
            v-if="checkAll" 
            v-model="checkedAll" 
            :indeterminate="isIndeterminate" 
            class="el-input-checkall"
            @change="handleCheckAllChange"
        >
            全选
        </el-checkbox>
        <el-checkbox-group 
            v-model="_value" 
            v-bind="$attrs"
            class="checkbox-custom-options" 
            @change="handleCheckedChange" 
        >
            <el-checkbox 
                v-for="option in options" 
                :key="option.value"
                :label="option.value"
                :disabled="option.disabled"
            >
                {{ option.label }}
                <label class="checkbox-ext-message">{{ extMessage }}</label>
            </el-checkbox>
        </el-checkbox-group>
    </div>
</template>

<script>
export default {
  name: "CheckboxCustom",
  
  inheritAttrs: false,

  props: {
    value: {
      type: Array,
      default: () => []
    },
    checkAll: {
      type: Boolean,
      default: false
    },
    defaultCheckAll: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      require: true,
      default: () => []
    },
    extMessage:{
      type: String,
      default: null
    },
    reset: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      key: `CheckboxCustomID-${Math.random()
        .toString(36)
        .slice(2)}`,
      checkedAll: false,
      isIndeterminate: false,
      defaultCheckedAll: []
    };
  },

  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  },

  watch: {
    value(val, oldVal) {
      if (val && val !== oldVal && val.length === this.options.length) {
        this.checkedAll = true;
      } 
    },
    
    options(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.init();
      }
    },
    
    reset(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.init();
        this.$emit("update:reset", false);
      }
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.handleCheckedChange(this._value);
      if (this.checkAll) {
        this.defaultCheckedAll = this.options.map(item => item.value);
        if (this.defaultCheckAll) {
          this.handleCheckAllChange(true);
          this.handleCheckedChange(this.defaultCheckedAll);
        }
      }
    },
    handleCheckAllChange(isCheckAll) {
      this._value = isCheckAll ? [...this.defaultCheckedAll] : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkedAll = checkedCount === this.options.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.options.length;
    }
  }
};
</script>

<style>
.el-input-checkall {
  margin-right: 30px;
}
.checkbox-custom,
.checkbox-custom-options {
  display: inline-block;
}
.checkbox-ext-message{
  margin-left: 10px;
  color: red
}
</style>
